import { render, staticRenderFns } from "./location-image.vue?vue&type=template&id=0adb3d8a&scoped=true&"
import script from "./location-image.vue?vue&type=script&lang=js&"
export * from "./location-image.vue?vue&type=script&lang=js&"
import style0 from "./location-image.vue?vue&type=style&index=0&id=0adb3d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb3d8a",
  null
  
)

export default component.exports